export default __webpack_public_path__ + "static/media/iconPlusBlack.64b63b26.svg";